import splitRangeIntoTwoPartsIfItIsCircular from "./splitRangeIntoTwoPartsIfItIsCircular";
function isPositionWithinRange(position, range, sequenceLength, includeStartEdge, includeEndEdge) {
  const ranges = splitRangeIntoTwoPartsIfItIsCircular(range, sequenceLength);
  const positionFits = ranges.some(function(range2) {
    if (includeStartEdge ? position < range2.start : position <= range2.start) {
      return false;
    } else {
      if (includeEndEdge ? position <= range2.end + 1 : position <= range2.end) {
        return true;
      } else {
        return false;
      }
    }
  });
  return positionFits;
}
export default isPositionWithinRange;
